module.exports = {
  "zones": {
    "Europe/Madrid": ["z", {
      "wallclock": 283996800000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 283993200000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": -940208400000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -940208400000,
      "save": 0,
      "rules": "Spain"
    }, {
      "wallclock": -2177453684000,
      "format": "WE%sT",
      "abbrev": "WET",
      "offset": 0,
      "posix": -2177452800000,
      "save": 0,
      "rules": "Spain"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -884000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EU": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1984,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1983,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1981,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "Spain": [{
      "from": 1978,
      "to": 1978,
      "month": 3,
      "day": [7, 2],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1976,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 3,
      "day": [7, 2],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1976,
      "month": 2,
      "day": [7, 27],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1975,
      "month": 3,
      "day": [6, 12],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1975,
      "month": 9,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1949,
      "to": 1949,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1949,
      "to": 1949,
      "month": 9,
      "day": [7, 2],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1946,
      "month": 3,
      "day": [6, 13],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1946,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1944,
      "month": 9,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 4,
      "day": [7, 2],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1942,
      "month": 8,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1939,
      "to": 1939,
      "month": 9,
      "day": [7, 7],
      "time": 1500,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1938,
      "to": 1938,
      "month": 3,
      "day": [7, 2],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1938,
      "to": 1938,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1938,
      "to": 1938,
      "month": 9,
      "day": [7, 2],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1937,
      "to": 1937,
      "month": 5,
      "day": [7, 16],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1937,
      "to": 1937,
      "month": 9,
      "day": [7, 2],
      "time": 1500,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1926,
      "to": 1929,
      "month": 9,
      "day": [6, 1],
      "time": 1500,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1929,
      "to": 1929,
      "month": 3,
      "day": [7, 20],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1928,
      "to": 1928,
      "month": 3,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1927,
      "to": 1927,
      "month": 3,
      "day": [7, 9],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1926,
      "to": 1926,
      "month": 3,
      "day": [7, 17],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1924,
      "to": 1924,
      "month": 3,
      "day": [7, 16],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1924,
      "to": 1924,
      "month": 9,
      "day": [7, 4],
      "time": 1500,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1918,
      "to": 1919,
      "month": 9,
      "day": [7, 6],
      "time": 1500,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 3,
      "day": [7, 6],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 3,
      "day": [7, 15],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }]
  }
};